/*
 * @Author: weiyanna weiyanna@jd.com
 * @Date: 2026-06-09 14:41:48
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-06-09 14:48:37
 * @FilePath: /isp_International/src/pages/Forbidden403/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { Button } from 'antd';

import { FORBIDDEN403_IMAGE_URL } from '@/util/forbidden403Config';
import {
  clearHomepageInitHandledForCurrentLogin,
  clearHomepageInitPending,
  clearHomepageStatusFailedInCurrentLogin,
} from '@/util/homepageInitState';
import { clearStoredSelectedAddress } from '@/util/addressSelection';
import { MISSING_REQUEST_ID_REASON } from '@/util/requestIdCookie';
import { resetSessionBootstrap } from '@/util/sessionBootstrap';
import { clearStoredPostalCodeLocation } from '@/util/postalCodeAddress';

import styles from './index.module.scss';
import { reportRouteClick, wispClstag } from '@/dataPort/routeTrack';
import { useRouteExposure } from '@/dataPort/useRouteExposure';

const Forbidden403: React.FC = () => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const reason = new URLSearchParams(search).get('reason');
  // OA 免密进商城依赖 requestId；丢失时与通用无权限区分文案，引导从 OA 重新进入
  const message =
    reason === MISSING_REQUEST_ID_REASON
      ? TLT('缺少流程编号，无法继续访问商城，请从 OA 重新进入。')
      : TLT('抱歉，您没有权限访问此页面。');

  const messageExposure = useRouteExposure<HTMLParagraphElement>('Forbidden403_Message', { reason: reason || 'forbidden' });

  // 与 NavBar 退出登录一致：清 SSO / 会话缓存后跳转登录页，避免 403 无权限时用户被困
  const handleLogout = () => {
    reportRouteClick('Forbidden403_Logout', { reason: reason || 'forbidden' });
    fetch('//sso.jdindustry.com/exit', {
      method: 'GET',
      credentials: 'include',
    }).finally(() => {
      clearHomepageInitHandledForCurrentLogin();
      clearHomepageInitPending();
      clearHomepageStatusFailedInCurrentLogin();
      resetSessionBootstrap();
      clearStoredSelectedAddress();
      clearStoredPostalCodeLocation();
      window.location.href = WISP_LOGIN_URL;
    });
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        {/* 弱网下未加载完成的 <img> 不计入 LCP，须 eager + 固定尺寸让插图尽早成为 LCP */}
        <img
          className={styles.image}
          src={FORBIDDEN403_IMAGE_URL}
          alt=""
          width={120}
          height={120}
          loading="eager"
          {...({ fetchpriority: 'high' } as React.ImgHTMLAttributes<HTMLImageElement>)}
        />
        <p className={styles.message} ref={messageExposure.ref} clstag={messageExposure.clstag}>{message}</p>
        <Button type="primary" className={styles.logoutBtn} clstag={wispClstag('Forbidden403_Logout', 'Click')} onClick={handleLogout}>
          {TLT('退出登录')}
        </Button>
      </div>
    </div>
  );
};

export default Forbidden403;
